import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { dashboardOriginalReducer } from './dashboard.reducer';
import { DashboardMainSliceState, DashboardSliceKey } from './dashboard.state';

export const DashboardFeatureKey = 'Dashboard';
export interface DashboardFeatureState {
	[DashboardSliceKey]: DashboardMainSliceState;
}

export interface DashboardRootState extends IAppRootState {
	[DashboardFeatureKey]: DashboardFeatureState;
}

export const featureSelector =
	createFeatureSelector<DashboardFeatureState>(DashboardFeatureKey);

export const dashboardReducers: ActionReducerMap<DashboardFeatureState> = {
	[DashboardSliceKey]: dashboardOriginalReducer,
};
